module.exports = __webpack_public_path__ + "img/DasLetzteHochbett.15db59b6.jpg";